var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.matchAll` well-known symbol
defineWellKnownSymbol('matchAll');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es.symbol.match-all.js
// module id = 883
// module chunks = 47